import { render, staticRenderFns } from "./InfoChain.vue?vue&type=template&id=dc1c45ee&scoped=true"
import script from "./InfoChain.vue?vue&type=script&lang=js"
export * from "./InfoChain.vue?vue&type=script&lang=js"
import style0 from "./InfoChain.vue?vue&type=style&index=0&id=dc1c45ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1c45ee",
  null
  
)

export default component.exports